__turbopack_context__.v({
  "iconBadge": "progresschecklistgroup-module-scss-module__E_kxBW__iconBadge",
});
